import { Height } from "@mui/icons-material";

// Desktop Images Data
export const DESKTOP_DATA = [
    { 
        id: "01", 
        img: "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page3_4/Asset010.png",
        width: "auto",
        height: 200
    },
    { 
        id: "02", 
        img: "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page3_4/Asset011.png",
        width: "auto",
        height: 180
    },
    { 
        id: "03", 
        img: "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page3_4/Asset012.png",
        width: "auto",
        height: 160
    },
    { 
        id: "04", 
        img: "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page3_4/Asset013.png",
        width: "auto",
        height: 190
    },
    { 
        id: "05", 
        img: "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page3_4/Asset014.png",
        width: "auto",
        height: 170
    },
    { 
        id: "06", 
        img: "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page3_4/Asset015.png",
        width: "auto",
        height: 200
    },
    { 
        id: "07", 
        img: "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page3_4/Asset016.png",
        width: "auto",
        height: 180
    }
];

// Mobile Images Data
export const MOBILE_DATA = [
    { 
        id: "01", 
        img: "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/mobile/page3_4/Asset010.png",
        width: "100%",
        height: 200
    },
    { 
        id: "02", 
        img: "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/mobile/page3_4/Asset011.png",
        width: "100%",
        height: 140
    },
    { 
        id: "03", 
        img: "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/mobile/page3_4/Asset012.png",
        width: "100%",
        height: 130
    },
    { 
        id: "04", 
        img: "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/mobile/page3_4/Asset013.png",
        width: "100%",
        height: 145
    },
    { 
        id: "05", 
        img: "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/mobile/page3_4/Asset014.png",
        width: "100%",
        height: 135
    },
    { 
        id: "06", 
        img: "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/mobile/page3_4/Asset015.png",
        width: "100%",
        height: 150
    },
    { 
        id: "07", 
        img: "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/mobile/page3_4/Asset016.png",
        width: "100%",
        height: 140
    }
];
